<template>
  <div class="contact" id="contact-us">
    <div class="container">
      <div class="contact__wrapper" >
        <div class="contact__left">
          <div class="contact__form">
            <h2 class="contact__title">{{ t('home.contact.title') }}</h2>
            <div class="contact__form-box">
              <input
                  type="text"
                  :placeholder="t('fields.firstName')"
                  v-model="firstName"
              >
              <input
                  type="text"
                  :placeholder="t('fields.lastName')"
                  v-model="lastName"
              >
            </div>
            <input
                type="email"
                :placeholder="t('fields.email')"
                v-model="email"
            >
            <textarea
                :placeholder="t('fields.message')"
                v-model="message"
            />
            <ui-button @click="contact">
              {{ t('buttons.sendRequest') }}
              <img src="@icons/rightArrowBlue.svg" alt="">
            </ui-button>
          </div>
        </div>
        <img src="@images/contactImage.png" alt="" class="contact__image" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import {Processes} from "@/core/api/processes.js";
import {ElNotification} from "element-plus";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n()
const companyStore = useCompanyStore()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const message = ref('')

const contact = async () => {
  if (
      !firstName.value.trim() ||
      !lastName.value.trim() ||
      !email.value.trim() ||
      !message.value.trim()
  ) {
    ElNotification({
      title: t('popup.error'),
      message: t('popup.fillAllFields'),
      type: 'error'
    })
    return
  }

  const res = await Processes.contact({
    name: firstName.value + lastName.value,
    email: email.value,
    subject: '',
    message: message.value
  })

  if (res.errors) {
    ElNotification({
      title: t('popup.error'),
      message: res.errors[0].message,
      type: 'error'
    })
  } else {
    ElNotification({
      message: t('popup.contactUs'),
      type: 'success'
    })

    firstName.value = ''
    lastName.value = ''
    email.value = ''
    message.value = ''
  }
}
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 50px;

  &__wrapper {
    padding-bottom: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 50px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 70px;

    color: #3D2A05;
    text-align: justify;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    width: 100%;

    & button {
      width: fit-content;
      border: #3B3B3B 1px solid;
      transition: 0.2s;

      color: #3D2A05;
      font-size: 21px;
      font-weight: 500;
      line-height: 27px;

      @include hover {
        border: #6D79E2 1px solid;
        box-shadow: 0 0 5px 1px #6F6DD3;;
      }
    }
  }

  &__title {
    color: #3D2A05;
    font-size: 63px;
    font-weight: 800;
    line-height: 63px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 500px;

    & div {
      display: flex;
      align-items: center;
      gap: 20px;

      & a {
        transition: 0.2s;

        @include hover {
          color: #cbcbcb;
        }
      }
    }

    & span {
      color: #714E0B;
      font-family: "Hanken Grotesk", sans-serif;
      font-size: 22px;
      font-weight: 200;
      line-height: 30px;
    }
  }

  &__form {
    border-radius: 16px;
    padding: 35px 30px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-box {
      display: flex;
      align-items: flex-start;
      gap: 15px;
    }

    & input {
      border-radius: 50px;
      background-color: rgba(170, 171, 242, 0.4);
      padding: 12px 15px;

      width: 100%;

      box-shadow: 14px 14px 13.9px 0 rgba(0, 0, 0, 0.10);

      color: #3B3B3B;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }

    & textarea {
      resize: none;
      height: 175px;
      border-radius: 20px;
      background-color: rgba(170, 171, 242, 0.4);
      padding: 12px 15px;

      box-shadow: 14px 14px 13.9px 0 rgba(0, 0, 0, 0.10);

      color: #3B3B3B;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
  }
}

@media (max-width: 1300px) {
  .contact {
    &__wrapper {
      flex-direction: column;
    }
  }
}

@media (max-width: 1100px) {
  .contact__image{
    display: none;
  }
}

@media (max-width: 750px) {

  .contact {
    &__wrapper {
      padding-block: 50px;
    }

    &__image{
      display: none;
    }

    &__title {
      font-size: 42px;
    }

    &__left {
      gap: 25px;
      font-size: 18px;
    }

    &__info {
      & span {
        font-size: 16px;
      }
    }

    &__form {
      width: 100%;

      &-box {
        flex-direction: column;
      }

      & input {
        width: 100%;
      }
    }
  }
}

</style>